import type { FunctionComponent } from 'react';
import { ContentBrick } from '../../../../../app-kit/components/ContentBrick/ContentBrick';
import { useSchoolPageBySlugTabContentQuery } from '../../../../graphql/useSchoolPageBySlugTabContentQuery';
import { isContentOverview } from '../../../../helpers/isContentOverview';
import { PropertyCarousel } from '../../../../../app-kit/components/PropertyCarousel/PropertyCarousel';
import { generateRelativeDateFromUTCTimestamp } from '../../../../../app-kit/helpers/generateRelativeDateFromUTCTimestamp';

export const NearbySoldPropertiesBrickWithData: FunctionComponent = () => {
  const { data } = useSchoolPageBySlugTabContentQuery();
  const tabContent = data?.schoolPageBySlug?.tabContent;

  if (!tabContent || !isContentOverview(tabContent)) return null;

  const { propertiesRecentlySold } = tabContent;
  if (!propertiesRecentlySold || propertiesRecentlySold.properties.length === 0) return null;

  const { title, subtitle, properties, tracking } = propertiesRecentlySold;
  return (
    <ContentBrick title={title} subtitle={subtitle}>
      <PropertyCarousel
        properties={properties.map(
          ({
            pathV2,
            clickThroughTracking,
            priceV2,
            address,
            image,
            badgeV2,
            features,
            soldDate,
          }) => ({
            path: pathV2,
            clickThroughSource: clickThroughTracking,
            title: priceV2,
            titleExtra: soldDate ? generateRelativeDateFromUTCTimestamp(soldDate) : null,
            subtitle: address,
            image,
            badge: badgeV2,
            features: features?.map((feature) => ({ ...feature, iconName: feature.iconNameV2 })),
          }),
        )}
        tracking={tracking.showMoreProperties}
      />
    </ContentBrick>
  );
};
